module.exports = __webpack_public_path__ + "static/media/building-circled.aced8dd4.svg";